var CalendarMode;
(function (CalendarMode) {
    CalendarMode["MONTHLY"] = "monthly";
    CalendarMode["WEEKLY"] = "weekly";
})(CalendarMode || (CalendarMode = {}));
export default CalendarMode;
//# sourceMappingURL=calendar-mode.js.map